import React, { useState } from "react";
import { cloneCorrespondence } from "../service/cloneService";

export const CloneForm: React.FC = () => {
  const [originalId, setOriginalId] = useState("");
  const [nuevoId, setNuevoId] = useState("");
  const [entity, setEntity] = useState("");
  const [disabled, setDisabled] = useState(false);

  const copiarDocumento = async () => {
    try {
      setDisabled(true);
      if (!originalId || !nuevoId || !entity) {
        alert("Por favor, ingresa ambos IDs o id entidad");
        setDisabled(false);
        return;
      }
      cloneCorrespondence(originalId, nuevoId, entity);
      setDisabled(false);
    } catch (error) {
      console.error("Error al copiar el documento:", error);
      alert("Ocurrió un error al copiar el documento.");
      setDisabled(false);
    }
  };

  return (
    <div>
      <h2>Copiar Documento</h2>
      <input
        type="text"
        placeholder="ID del entidad"
        value={entity}
        onChange={(e) => setEntity(e.target.value)}
      />
      <br />
      <input
        type="text"
        placeholder="ID del documento original"
        value={originalId}
        onChange={(e) => setOriginalId(e.target.value)}
      />
      <br />
      <input
        type="text"
        placeholder="ID del nuevo documento"
        value={nuevoId}
        onChange={(e) => setNuevoId(e.target.value)}
      />
      <br />
      <button onClick={copiarDocumento} disabled={disabled}>
        Copiar Documento
      </button>
    </div>
  );
};

export default CloneForm;
